"use strict";

exports.__esModule = true;
exports.default = void 0;

var _data = _interopRequireDefault(require("./data.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// taken from https://www.npmjs.com/package/world-countries but pruned
// to reduce data size.
var _default = _data.default;
exports.default = _default;